var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning-block"},[(_vm.$resize && _vm.$mq.below(1439))?_c('div',{staticClass:"text"},[_vm._v("ИМЕЮТСЯ ПРОТИВОПОКАзания."),_c('br'),_vm._v("ознакомьтесь с инструкцией.")]):_vm._e(),(_vm.$resize && _vm.$mq.above(1440))?_c('div',{staticClass:"text text-width"},[_vm._v("ИМЕЮТСЯ ПРОТИВОПОКАзания. ознакомьтесь с инструкцией.")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fbb8458","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarningBlock.vue
// module id = null
// module chunks = 